import React, { useEffect } from "react";
import { Link, useLocation, matchPath } from "react-router-dom";
import "./pages-css/IsecNavbar.css";
import { useAuth } from "../../Context/UserContext";
import { Icon } from "@iconify/react";
const IsecNavbar = () => {

  const { userRole, isSidebarCollapsed, setIsSidebarCollapsed, fetchUnreadISECURIONMessageCount, isecCount } = useAuth();

  const location = useLocation();
  const { pathname } = location;

  const isCurrentPage = (pages) => {
    const patternArray = Array.isArray(pages) ? pages : [pages];
    return patternArray.some((pattern) =>
      matchPath({ path: pattern, end: true }, pathname)
    );
  };

  useEffect(() => {
    fetchUnreadISECURIONMessageCount()

    const intervalId = setInterval(() => {
      fetchUnreadISECURIONMessageCount();
    }, 90000);

    return () => clearInterval(intervalId);
  }, [])

  return (
    <div
      className={
        !isSidebarCollapsed
          ? "isec_sidebar_container"
          : "isec_sidebar_full_container"
      }
      onMouseLeave={() => setIsSidebarCollapsed(false)}
    >
      {/* dashboard */}
      <Link
        to="/isecurion_dash"
        className="isec_sidebar_link nav-link-with-tooltip"
      >
        <div
          className={
            isCurrentPage("/isecurion_dash")
              ? "isec_active_icon"
              : "isec_inactive_icon"
          }
        >
          {isSidebarCollapsed && (
            <div style={{ paddingLeft: "12px", paddingTop: '0px', paddingBottom: "4px" }}>
              <Icon
                icon="ri:dashboard-line"
                width="19"
                height="19"
                color="#fff"
              />
              <div className="isec_sidebar_sidebar_list_name">Dashboard</div>
            </div>
          )}
          {!isSidebarCollapsed && (
            <>
              <Icon
                icon="ri:dashboard-line"
                width="19"
                height="19"
                color="#fff"
              />
              <span className="tooltip-text">Dashboard</span>
            </>
          )}
        </div>
      </Link>

      <Link
        to="/isecurion/projects/all"
        className="isec_sidebar_link nav-link-with-tooltip">
        <div
          className={
            isCurrentPage([
              "/projects/status/:id",
              "/isecurion/projects/all",
              "isecurion_dash/status/:id/addvuln",
              "/isecurion/viewvulnerabilities/:id"
            ])
              ? "isec_active_icon"
              : "isec_inactive_icon"
          }
        >
          {isSidebarCollapsed && (
            <div style={{ paddingLeft: "12px", paddingTop: '0px', paddingBottom: "4px" }}>
              <Icon
                icon="clarity:folder-open-line"
                width="19"
                height="19"
                color="#fff"
              />
              <div className="isec_sidebar_sidebar_list_name">Project</div>
            </div>
          )}
          {!isSidebarCollapsed && (
            <>
              <Icon
                icon="clarity:folder-open-line"
                width="19"
                height="19"
                color="#fff"
              />
              <span className="tooltip-text">Project</span>
            </>
          )}
        </div>
      </Link>

      {/* add user */}
      {userRole === "manager" && (
        <Link
          to="/isecurion/adduser"
          className="isec_sidebar_link nav-link-with-tooltip"
        >
          <div
            className={
              isCurrentPage("/isecurion/adduser")
                ? "isec_active_icon"
                : "isec_inactive_icon"
            }
          >
            {isSidebarCollapsed && (
              <div style={{ paddingLeft: "12px", paddingTop: '0px', paddingBottom: "4px" }}>
                <Icon
                  icon="tdesign:user-1"
                  width="19"
                  height="19"
                  color="#fff"
                />
                <div className="isec_sidebar_sidebar_list_name">Manage User</div>
              </div>
            )}
            {!isSidebarCollapsed && (
              <>
                <Icon
                  icon="tdesign:user-1"
                  width="19"
                  height="19"
                  color="#fff"
                />
                <span className="tooltip-text">Manage User</span>
              </>
            )}
          </div>
        </Link>
      )}

      {/* Report */}
      {userRole !== "manager" && (
        <Link
          to="/isecurion/generatereport"
          className="isec_sidebar_link nav-link-with-tooltip"
        >
          <div
            className={
              isCurrentPage("/isecurion/generatereport")
                ? "isec_active_icon"
                : "isec_inactive_icon"
            }
          >
            {isSidebarCollapsed && (
              <div style={{ paddingLeft: "12px", paddingTop: '0px', paddingBottom: "4px" }}>
                <Icon
                  icon="bi:file-earmark-word"
                  width="19"
                  height="19"
                  color="#fff"
                />
                <div className="isec_sidebar_sidebar_list_name">Report</div>
              </div>
            )}

            {!isSidebarCollapsed && (
              <>
                <Icon
                  icon="bi:file-earmark-word"
                  width="19"
                  height="19"
                  color="#fff"
                />
                <span className="tooltip-text">Report</span>
              </>
            )}
          </div>
        </Link>
      )}

      {/* messenger */}
      {userRole !== "manager" && (
        <Link
          to="/isecurion/messenger"
          className="isec_sidebar_link nav-link-with-tooltip"
        >
          <div
            className={
              isCurrentPage("/isecurion/messenger")
                ? "isec_active_icon"
                : "isec_inactive_icon"
            }
          >
            {isSidebarCollapsed && (
              <div style={{ paddingLeft: "12px", paddingTop: '0px', paddingBottom: "4px" }}>
                <Icon
                  icon="mingcute:message-2-line"
                  width="19"
                  height="19"
                  color="#fff"
                />
                {isecCount > 0 && (
                  <span
                    style={{
                      position: "absolute",
                      top: "6px",
                      left: "27px",
                      background: "#E76A34",
                      color: "white",
                      borderRadius: "50%",
                      padding: "2px 5px",
                      fontSize: "10px"
                    }}
                  >
                    {isecCount > 9 ? '9+' : isecCount}
                  </span>
                )}
                <div className="isec_sidebar_sidebar_list_name">Chatbox</div>
              </div>
            )}

            {!isSidebarCollapsed && (
              <>
                <Icon
                  icon="mingcute:message-2-line"
                  width="19"
                  height="19"
                  color="#fff"
                />
                {isecCount > 0 && (
                  <span
                    style={{
                      position: "absolute",
                      top: "6px",
                      right: "16px",
                      background: "#E76A34",
                      color: "white",
                      borderRadius: "50%",
                      padding: "2px 5px",
                      fontSize: "10px"
                    }}
                  >
                    {isecCount > 9 ? '9+' : isecCount}
                  </span>
                )}
                <span className="tooltip-text">Chatbox</span>
              </>
            )}
          </div>
        </Link>
      )}
    </div>

  );
};

export default IsecNavbar;